export default __webpack_public_path__ + "img/fJwnLTZi.38eb4f61.svg";